import React from 'react'
import { Image } from '../../../../utils/image'
import { mediaBlockClasses } from '../../../../utils/style'
import { getClassName } from '../../../../utils/utils'
import { Video } from '../../../components/video'
import { useInView } from '../../../hooks/useInView'
import { MediaBlock } from '../blocksState'

export type MediaBlockStyle = Partial<{
  blockClassName: string
  inviewClassName: string
  innerClassName: string
  headerClassName: string
  titleClassName: string
  introClassName: string
  contentClassName: string
  figureContentWidthClassName: string
  figureFullWidthClassName: string
  figureImageClassName: string
  figureVideoClassName: string
  mediaClassName: string
  imageClassName: string
  pictureClassName: string
  figCaptionClassName: string
  captionClassName: string
  sourceClassName: string
  cookiesClassName: string
  cookiesInnerClassName: string
  cookiesTextClassName: string
  cookiesClickableClassName: string
}>

export const MediaBlockLayout = (
  props: MediaBlock & {
    videoCookieAccepted: boolean
    acceptVideoCookie: () => void
  }
) => {
  const { inview, index, title, intro, items, videoCookieAccepted, acceptVideoCookie } = props
  const classes = mediaBlockClasses
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("MediaBlockLayout inView:", inview),
    !inview?.triggerOnce
  )
  return (
    <section
      key={`block-${index}`}
      id={`io-${index}`}
      ref={ref}
      className={getClassName(classes, 'blockClassName', 'container') + ' ' + (inView ? getClassName(classes, 'inviewClassName', 'inview') : '')}
    >
      <div className={getClassName(mediaBlockClasses, 'innerClassName', 'py-5')}>
        {(title || intro) && (
          <header className={getClassName(mediaBlockClasses, 'headerClassName', 'container text-center')}>
            {title && (
              <h2 className={getClassName(mediaBlockClasses, 'titleClassName', '3')}>
                <span id={`${index}`} aria-hidden="true" className="block__anchor" />
                {title}
              </h2>
            )}
            {intro && <p className={getClassName(mediaBlockClasses, 'introClassName', '')}>{intro}</p>}
          </header>
        )}

        {items.length > 0 && (
          <div className={getClassName(mediaBlockClasses, 'contentClassName', 'content')}>
            {items.map((item, itemIndex) => {
              const isFw = item.display === 'full-with'

              return (
                <figure
                  key={`media-${index}-${itemIndex}`}
                  className={
                    getClassName(
                      mediaBlockClasses,
                      isFw ? 'figureFullWidthClassName' : 'figureContentWidthClassName',
                      `${isFw ? 'figure--fw' : 'figure--cw'}`
                    ) +
                    ' ' +
                    getClassName(
                      mediaBlockClasses,
                      item.kind === 'image' ? 'figureImageClassName' : 'figureVideoClassName',
                      'mb-0'
                    )
                  }
                >
                  {item.kind === 'image'
                    ? item.image && (
                      <div className={getClassName(mediaBlockClasses, 'mediaClassName', 'block__media')}>
                        <Image
                          {...item.image}
                          classNames={{
                            image: getClassName(mediaBlockClasses, 'imageClassName', 'block__media w-100'),
                            picture: getClassName(mediaBlockClasses, 'pictureClassName', ''),
                          }}
                        />
                      </div>
                    )
                    : item.kind === 'video' &&
                    item.video && (
                      <Video
                        url={item?.video?.url}
                        videoCookieAccepted={videoCookieAccepted}
                        acceptVideoCookie={acceptVideoCookie}
                        className="figure__video"
                      />
                    )}

                  {(item.caption || item.source) && (
                    <figcaption className={getClassName(mediaBlockClasses, 'figCaptionClassName', 'mt-2')}>
                      {item.caption && (
                        <p
                          className={getClassName(
                            mediaBlockClasses,
                            'captionClassName',
                            'small text-secondary text-center m-0'
                          )}
                        >
                          {item.caption}
                        </p>
                      )}
                      {item.source && (
                        <p
                          className={getClassName(
                            mediaBlockClasses,
                            'sourceClassName',
                            'small text-secondary text-center m-0'
                          )}
                        >
                          {item.source}
                        </p>
                      )}
                    </figcaption>
                  )}
                </figure>
              )
            })}
          </div>
        )}
      </div>
    </section>
  )
}
